<template>
  <div class="pa-5">
    <v-card>
      <v-card-title>
        <h2 class="text-h5 font-weight-bold">
          {{ $t('tsl.title') }}
        </h2>
      </v-card-title>
      <v-card-text>
        <div class="text-center pa-10">
          <v-icon size="100" color="grey lighten-1">
            mdi-package-variant
          </v-icon>
          <p class="text-h6 grey--text mt-5">
            {{ $t('tsl.comingSoon') }}
          </p>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'TSL'
}
</script>
